import { useStores } from 'hooks';
import { observer } from 'mobx-react-lite';
import React, { useState } from 'react';
import { Stat } from './Stat';
import { Container } from './Styles';
import { TimeLeft } from './TimeLeft';

export const colors = {
  black: '#000000',
  blue: '#0095E8',
  default: '#e7e7e7',
  green: '#21BA45',
  red: '#DB2828',
  white: '#ffffff',
  yellow: '#FBCC08',
};

export const getPercentRemaining = (value, total, colors, label = '% Comp') => {
  const { black, none, red } = colors;
  const pct = 100 - Math.floor((value / total) * 100);
  return {
    bgColor: none,
    color: pct >= 95 ? red : black,
    label,
    value: `${pct}%`,
  };
};

export const getTotalUnits = (value, colors, label = 'Total') => {
  const { bgColor, color } = colors;
  return {
    bgColor,
    color,
    label,
    value,
  };
};

export const Stats = observer(() => {
  const {
    AuctionStore: { runList, runListStats, auctionInfo },
    BidStore: {
      auction: { monitorChatOnly },
    },
  } = useStores();

  const [showValue, setShowValue] = useState(true);

  const runListCount = (runList && runList.length) || 0;

  const { black, blue, default: none, green, red, white, yellow } = colors;
  const getValueByProductState = (productState) =>
    (runListStats && runListStats[productState]) || 0;

  const getPctByProductState = (productState) => {
    const value = (runListStats && runListStats[productState]) || 0;
    const pct = ((value / runListCount) * 100).toFixed(1);
    return `${pct}%`;
  };

  // const getConversionRate = () => {
  //   // 100 * Sold / (Offered - Units Left) (format ##.0%)
  //   const SOLD = getValueByProductState(3);
  //   const OFFERED = runListCount;
  //   const UNITS_LEFT = getValueByProductState(0) + getValueByProductState(1);
  //   const pct = ((SOLD / (OFFERED - UNITS_LEFT)) * 100).toFixed(1);
  //   const { red, green } = colors;

  //   return {
  //     bgColor: colors.default,
  //     color: pct >= 80 ? green : red,
  //     label: 'Conv',
  //     value: `${pct}%`,
  //   };
  // };

  // const getPendingConversionRate = () => {
  //   // 100 * (Sold + Pending) / (Offered - Units Left) (format ##.0%)
  //   const SOLD = getValueByProductState(3);
  //   const PENDING = getValueByProductState(2);
  //   const OFFERED = runListCount;
  //   const UNITS_LEFT = getValueByProductState(0) + getValueByProductState(1);
  //   const pct = ((100 * (SOLD + PENDING)) / (OFFERED - UNITS_LEFT)).toFixed(1);
  //   const { red, green } = colors;
  //   return {
  //     bgColor: colors.default,
  //     color: pct >= 80 ? green : red,
  //     label: 'PndCnv',
  //     value: `${pct}%`,
  //   };
  // };

  // const getMaxConversionRate = () => {
  //   // 100 * (Sold + Units Left + Pending ) / Offered (format ##.0%)
  //   const SOLD = getValueByProductState(3);
  //   const PENDING = getValueByProductState(2);
  //   const OFFERED = runListCount;
  //   const UNITS_LEFT = getValueByProductState(0) + getValueByProductState(1);
  //   const pct = ((100 * (SOLD + UNITS_LEFT + PENDING)) / OFFERED).toFixed(1);
  //   const { red, green } = colors;
  //   return {
  //     bgColor: colors.default,
  //     color: pct >= 80 ? green : red,
  //     label: 'MaxCnv',
  //     value: `${pct}%`,
  //   };
  // };

  const data = {
    noSale: {
      bgColor: red,
      color: white,
      label: 'No Sale',
      pct: getPctByProductState(4),
      productState: 4,
      value: getValueByProductState(4),
    },
    none: {
      bgColor: none,
      color: getValueByProductState(0) <= 10 ? red : black,
      label: 'Remain',
      pct: getPctByProductState(0),
      productState: 0,
      value: getValueByProductState(0),
    },
    open: {
      bgColor: blue,
      color: white,
      label: 'Open',
      pct: getPctByProductState(1),
      productState: 1,
      value: getValueByProductState(1),
    },
    pulled: {
      bgColor: none,
      color: black,
      label: 'Pulled',
      pct: getPctByProductState(5),
      productState: 5,
      value: getValueByProductState(5),
    },
    sold: {
      bgColor: green,
      color: white,
      label: 'Sold',
      pct: getPctByProductState(3),
      productState: 3,
      value: getValueByProductState(3),
    },
    subjectTo: {
      bgColor: yellow,
      color: black,
      label: 'Pending',
      pct: getPctByProductState(2),
      productState: 2,
      value: getValueByProductState(2),
    },
  };

  const notStatusedItem = data['none'];
  const subjectToItem = data['subjectTo'];
  const soldItem = data['sold'];
  const noSaleItem = data['noSale'];

  const pctComplete = getPercentRemaining(notStatusedItem.value, runListCount, {
    black,
    none,
    red,
  });

  const totalUnits = getTotalUnits(runListCount, {
    bgColor: black,
    color: white,
  });

  // const conversionRate = getConversionRate();
  // const pendingConversionRate = getPendingConversionRate();
  // const maxConversionRate = getMaxConversionRate();

  const uiProductStateData = [
    notStatusedItem,
    soldItem,
    subjectToItem,
    noSaleItem,
  ];

  if (!monitorChatOnly) {
    return null;
  }

  return (
    <Container>
      <TimeLeft
        defaultSecPerUnit={60}
        label="Est. Time Remaining:"
        notStatusedCount={notStatusedItem.value}
        auctionStart={
          window.localStorage.getItem('startTimeInSanDiego') ||
          auctionInfo.startTime
        }
        totalUnitsRun={totalUnits.value - notStatusedItem.value}
      />
      <Stat
        bgColor={pctComplete.bgColor}
        color={pctComplete.color}
        text={pctComplete.label}
        value={pctComplete.value}
      />
      {uiProductStateData.map(
        ({ bgColor, color, label, pct, value }, index) => (
          <Stat
            bgColor={bgColor}
            color={color}
            key={index}
            onClick={() => setShowValue((prevState) => !prevState)}
            text={label}
            value={showValue ? value : pct}
          />
        ),
      )}
      <Stat
        bgColor={totalUnits.bgColor}
        color={totalUnits.color}
        text={totalUnits.label}
        value={totalUnits.value}
      />
      {/* <Stat
        bgColor={conversionRate.bgColor}
        color={conversionRate.color}
        text={conversionRate.label}
        value={conversionRate.value}
      />
      <Stat
        bgColor={pendingConversionRate.bgColor}
        color={pendingConversionRate.color}
        text={pendingConversionRate.label}
        value={pendingConversionRate.value}
      />
      <Stat
        bgColor={maxConversionRate.bgColor}
        color={maxConversionRate.color}
        text={maxConversionRate.label}
        value={maxConversionRate.value}
      /> */}
    </Container>
  );
});

export default Stats;
